import { useEffect, useState } from 'react'
import { Platform } from 'react-native'

import { isApp } from '@zet/utils'
import { navigationRef } from '@zet/utils/navigation'

type Params = {
  showIneligible?: 'true' | 'false'
  isB2C?: 'true' | 'false'
  hasMagnetCard?: 'true' | 'false'
  b2cReward?: 'amazon' | 'zetCoins'
}

export const useB2C = () => {
  const params = navigationRef?.getCurrentRoute()?.params as Params
  const isB2C = params?.isB2C?.toString()?.toLowerCase() === 'true'
  const showIneligible =
    params?.showIneligible?.toString()?.toLowerCase() === 'true' ||
    Platform.OS === 'web'
  const hasMagnetCard =
    params?.hasMagnetCard?.toString()?.toLowerCase() === 'true'
  const b2cRewardType = params?.b2cReward

  // this will help to re-render and re-calculate the isB2C and showIneligible
  const [isNavigationReady, setIsNavigationReady] = useState(isApp)

  useEffect(() => {
    const removeListener = navigationRef.addListener('state', () => {
      const isReady = navigationRef.isReady()
      if (isReady) {
        setIsNavigationReady(isReady)
        removeListener()
      }
    })

    return removeListener
  }, [])

  return {
    isB2C,
    b2cRewardType,
    showIneligible,
    hasMagnetCard,
    isNavigationReady,
  }
}
